import React from "react";
import styled from "styled-components";

const Wrapper = styled.div.attrs({ className: "inspector-status-selector" })`
  display: flex;
  align-items: stretch;
  border: 1px solid var(--card-border);
  border-radius: 4px;
  overflow: hidden;
  background: var(--panel-bg);
`;

const Option = styled.button`
  flex: 1;
  padding: 6px 12px;
  font-size: 13px;
  border: none;
  cursor: pointer;
  opacity: 1;
  border-right: 1px solid var(--card-border);
  &:last-child {
    border-right: none;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
`;

/**
 * Inspector status: Action or OK. value can be "" | "action" | "ok" ("" = neither selected).
 */
export default function InspectorStatusSelector({ value, onChange, disabled }) {
  const options = [
    { key: "action", label: "Action" },
    { key: "ok", label: "OK" },
  ];
  const current = value ?? "";

  return (
    <Wrapper>
      {options.map(({ key, label }) => {
        const isActive = current === key;
        return (
          <Option
            key={key}
            type="button"
            className={ `inspector-status-option inspector-status-option--${key}${isActive ? " inspector-status-option--active" : ""}` }
            data-active={isActive}
            disabled={disabled}
            onClick={() => !disabled && onChange(key)}
          >
            {label}
          </Option>
        );
      })}
    </Wrapper>
  );
}
